import { makeStyles, Paper, TextField, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { DefaultInputProps } from '../../types/types';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             // minWidth: 320,
//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         }
//     }),
// );

export default function IrpefCollaboratore2(props: DefaultInputProps) {
    // const classes = useStyles();
    const gClasses = globalStyles();
    const { state } = props;

    return (
        <React.Fragment>
            {state.datiCollaboratore2.nomeCognome2 !== undefined && state.datiCollaboratore2.nomeCognome2 !== "" ?
                (<Paper className={gClasses.mainPaper}>
                    <SectionTitle text="Collaboratore 2"></SectionTitle>
                    <TextField
                        label="Collaboratore 2"
                        value={state.datiCollaboratore2.nomeCognome2}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{tabIndex: -1}}
                        margin="normal"
                    />
                    <NumberField
                        name=""
                        label="Contr. IVS"
                        value={state.irpefCollaboratore2.H62}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Redditi</Typography>
                    <NumberField
                        name=""
                        label="Pensione"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E123}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Lav. dipendente e assimilati"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E124}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Assimilati lav. dipendente"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E125}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Partecipazione Impresa famigliare"
                        value={state.datiCollaboratore2.altriDatiPersonali_J130}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Diversi lettere i) e l)"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E126}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Fabbricati locati"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E127}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Altri"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E128}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Abitazione principale"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E129}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Redditi a cedolare secca"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E131}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Reddito complessivo"
                        value={state.irpefCollaboratore2.E75}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Redd. compl. per detraz."
                        value={state.irpefCollaboratore2.E76}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Oneri deducibili"
                        value={state.irpefCollaboratore2.I64}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Reddito imponibile"
                        value={state.irpefCollaboratore2.I65}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Irpef lorda"
                        value={state.irpefCollaboratore2.I66}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Detrazioni</Typography>
                    <NumberField
                        name=""
                        label="Familiari a carico"
                        value={state.irpefCollaboratore2.I68}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Lavoro dipend."
                        value={state.irpefCollaboratore2.I69}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Pensione"
                        value={state.irpefCollaboratore2.I70}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Lav. non dipend."
                        value={state.irpefCollaboratore2.I71}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Altre"
                        value={state.datiCollaboratore2.altriDatiPersonali_L127}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Tot. Detrazioni"
                        value={state.irpefCollaboratore2.I73}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Irpef netta"
                        value={state.irpefCollaboratore2.M69}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Addizionali Irpef</Typography>
                    <NumberField
                        name=""
                        label="Regionale"
                        value={state.irpefCollaboratore2.K73}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name=""
                        label="Comunale"
                        value={state.irpefCollaboratore2.M73}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                </Paper>) : <p></p>}
        </React.Fragment>
    );
}